import { AxiosError } from 'axios';

interface ErrorResponse {
  message?: string;
  errors?: { message: string }[];
}

export const handleError = (error: AxiosError<ErrorResponse>) => {
  let errorMessage = '';
  if (error.response) {
    const data = error.response.data;
    if (data.errors && Object.values(data.errors).length > 0) {
      const errors = Object.values(data.errors);

      errors.forEach((err) => {
        errorMessage += `${err}\n`;
      });
    } else {
      errorMessage = `${data.message || 'No additional details provided'}`;
    }
  } else if (error.request) {
    errorMessage = 'No response received from the server.';
  } else {
    errorMessage = `Request error: ${error.message}`;
  }
  console.error(errorMessage);
  return errorMessage;
};

export const printErrorToConsole = (e: unknown): void => {
  if (e instanceof Error) {
    console.error('Error:', e.message);
    if (e.stack) {
      console.error('Stack trace:', e.stack);
    }
  } else if (typeof e === 'string') {
    console.error('Error:', e);
  } else {
    console.error('Unknown error:', JSON.stringify(e, null, 2));
  }
};
